var r = /* @__PURE__ */ ((u) => (u.Short = "short", u.Medium = "medium", u.Long = "long", u))(r || {}), h = /* @__PURE__ */ ((u) => (u.Auto = "auto", u.H12 = "h12", u.H23 = "h23", u))(h || {});
export {
  r as D,
  h as T
};
